import Backbone from "backbone";
import SalesforceSettingsModel from "src/settings/SalesforceSettingsModel";

const SalesforceSettingsCollection = Backbone.Collection.extend({
    url: "/api/v2/settings/salesforce",
    model: SalesforceSettingsModel,
});

export default SalesforceSettingsCollection;
